import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-icon-mime',
  templateUrl: './icon-mime.component.html',
  styleUrls: ['./icon-mime.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconMimeComponent implements OnInit {
  @Input() mime: string;
  @Input() classIcon = '';
  icon = 'paperclip';
  color = '#333';
  constructor(private cd: ChangeDetectorRef) {}
  ngOnInit(): void {
    this.cd.detach();
    switch (this.mime) {
      case 'video/mp4':
      case 'avi':
      case 'm4v':
      case 'mov':
      case 'mpg':
      case 'mpeg':
      case 'mp4':
        this.icon = 'video';
        this.color = '#e57373';
        break;
      case 'apk':
      case 'deb':
      case 'zip':
      case 'tar':
      case 'jar':
      case 'rar':
      case '7z':
      case 'gz':
        this.icon = 'archive';
        this.color = '#76b979';
        break;
      case 'mp3':
      case 'ogg':
      case 'waw':
        this.icon = 'music';
        this.color = '#ba68c8';
        break;
      case 'png':
      case 'jpeg':
      case 'jpg':
      case 'webp':
      case 'gif':
      case 'ai':
      case 'raw':
      case 'tiff':
      case 'bmp':
      case 'ico':
      case 'psd':
        this.icon = 'image';
        this.color = '#ffae38';
        break;
      case 'txt':
      case 'pdf':
      case 'xml':
      case 'csv':
      case 'doc':
      case 'rtx':
      case 'docx':
      case 'html':
      case 'odt':
        this.icon = 'file-text';
        this.color = '#77a5d6';
        break;
      default:
        this.icon = 'paperclip';
        break;
    }
    this.cd.detectChanges();
  }
}
